/*
 * @Author: Fan
 * @Date: 2020-04-26 12:13:42
 * @description:
 * @LastEditors: Fan
 */
import Rate from "./Rate";
import collectingKanban from "./collectingKanban";
import AIPolish from "./AIPolish";
export default [Rate, collectingKanban, AIPolish];
